export function parseSelectedUserIds(uidParam = "") {
  return uidParam.split(",").filter(Boolean);
}

export function buildUserSelectionSearchParams(searchParams, selectedUserIds = []) {
  const nextSearchParams = new URLSearchParams(searchParams);

  if (selectedUserIds.length) {
    nextSearchParams.set("uid", selectedUserIds.join(","));
  } else {
    nextSearchParams.delete("uid");
  }

  return nextSearchParams;
}

export function buildAllocationUsersForSelection({
  selectedUserIds = [],
  candidateUsers = [],
}) {
  if (!selectedUserIds.length) {
    return [];
  }

  const candidateUserMap = new Map();

  candidateUsers.forEach((user) => {
    if (user?.user_id !== undefined && user?.user_id !== null) {
      candidateUserMap.set(String(user.user_id), user);
    }
  });

  const users = selectedUserIds
    .map((userId) => candidateUserMap.get(String(userId)))
    .filter(Boolean);

  return users.length ? [{ team: "Multiple", users }] : [];
}
